import { combineReducers } from "redux";
import errors from "./errReducer";

import {
    registerUser,
    login,
    userDetails,
    userDetailsFromToken,
    setUserActivity,
    getUserActivity,
    getUserPreference,
    setUserPreference,
    setFeedback,
    menuOpenStatus,
    sendOTP,
    verifyOTP,
    completeProfile
} from "./user";

import {
    createQuiz,
    startAbsiteDiagnostic,
    getAbsiteDiagnosticReport,
    saveAbsiteDiagnosticProfile,
    submitQuiz,
    getCategories,
    getQuesCategories,
    getQuiz,
    getQuizHistory,
    getQuestionHistory,
    getStudentQuizHistory,
    getOverallQuizHistory,
    getOverallStudentQuizHistory,
    getQuestionMetadata,
    getDemoQuestionIds,
    reviewQuestion,
    getImage,
    getQuesFeedback,
    setQuesFeedback,
    setQuesCount,
    getQuesTutorFeedback,
    setQuesTutorFeedback,
    createTutorFeedbackBlock,
    endTutorFeedbackBlock,
    getCategoryPreferences,
    setCategoryPreferences,
    onTopicsSearch,
    onAutoCompleteTopicsSearch,
    getDemoQuestionMetadata,
    powerSearchUserInput
} from "./quiz";

import {
    createPaymentSession,
    updatePaymentStatus,
    getUserPackage,
    getUserPayments,
    cancelSubscription,
    selectPlan,
    getActivePlans
} from './payment';

import {
    getInvitations,
    sendInvitation,
    resendInvitation,
    getComment,
    setComment,
    getStudentFeedbackAll,
    getTutorFeedbackAll,
    getAbsiteProgramSummary,
    getAllPlans,
    createPlan,
    updatePlan,
    deletePlan,
    sendInvites,
    getUsersByRole,
    getPaymentsByUser,
    refundBooking
} from './admin';

import {
    fetchQlink,
    publishQlink,
    revokeQlink
} from './qlink';

import { referral } from './referral';

const rootReducer = combineReducers({
    errors,
    registerUser,
    loggedInUser: login,
    userDetailsFromToken: userDetailsFromToken,
    studentDetails: userDetails,
    createQuiz,
    startAbsiteDiagnostic,
    absiteDiagnosticReport: getAbsiteDiagnosticReport,
    absiteDiagnosticProfile: saveAbsiteDiagnosticProfile,
    quizDetails: getQuiz,
    submitQuiz,
    categoriesList: getCategories,
    quesCategoriesList: getQuesCategories,
    quizHistory: getQuizHistory,
    questionHistory: getQuestionHistory,
    studentQuizHistory: getStudentQuizHistory,
    overallQuizHistory: getOverallQuizHistory,
    overallStudentQuiz: getOverallStudentQuizHistory,
    questionMetadata: getQuestionMetadata,
    reviewQuestion,
    paymentSession: createPaymentSession,
    paymentStatus: updatePaymentStatus,
    userPackage: getUserPackage,
    setUserActivity,
    userActivity: getUserActivity,
    userPayments: getUserPayments,
    cancelSubscription,
    invitationsList: getInvitations,
    sendInvitation,
    resendInvitation,
    getUserPreference,
    setUserPreference,
    getComment,
    setComment,
    setFeedback,
    getImage,
    getQuesFeedback,
    setQuesFeedback,
    quesCount: setQuesCount,
    getQuesTutorFeedback,
    setQuesTutorFeedback,
    getStudentFeedbackAll,
    getTutorFeedbackAll,
    absiteProgramSummary: getAbsiteProgramSummary,
    menuOpenStatus,
    createTutorFeedbackBlock,
    endTutorFeedbackBlock,
    getAllPlans,
    createPlan,
    updatePlan,
    deletePlan,
    selectPlan,
    getActivePlans,
    sendInvites,
    getUsersByRole,
    getPaymentsByUser,
    refundBooking,
    getCategoryPreferences,
    setCategoryPreferences,
    onTopicsSearch,
    onAutoCompleteTopicsSearch,
    fetchQlink,
    publishQlink,
    revokeQlink,
    getDemoQuestionMetadata,
    getDemoQuestionIds,
    powerSearchUserInput,
    sendOTP,
    verifyOTP,
    completeProfile,
    referral
});

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) =>
    rootReducer(action.type === "LOGOUT" ? undefined : state, action);
